
import { Component, Prop, Vue } from "vue-property-decorator";
import { TCase_Table } from "@/models/cases_expert_cases";
import { HIGH_RISK_ELIGIBILITY_RESULT } from "@/constants/assessment";
import {
  CASE_CREATION_SERVICE_STEP,
  DATA_AND_DOCUMENTS_SUBMISSION_SERVICE_STEP,
  EXPERT_REVIEW_SUBMISSION_SERVICE_STEP,
  ADDITIONAL_INFO_FOR_EXPERT_SERVICE_STEP,
  PAYMENT_SERVICE_STEP,
  APPLICATION_SUBMISSION_SERVICE_STEP,
  VISA_DECISION_SERVICE_STEP,
  COS_CREATION_SERVICE_STEP,
} from "@/constants/services";

const STATUS_COLUMN_CLASS = "status";

@Component({
  components: {
    ServicesTablePlaceholder: () =>
      import("@/modules/Services/Components/Table/ServicesTablePlaceholder.vue"),
  },
})
export default class EmployerServicesTableSL extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly cases!: TCase_Table[];
  @Prop({ type: Boolean, default: false }) readonly showHelloMessage!: boolean;
  @Prop({ type: String, default: "" }) readonly savedFilters!: string;

  get labels() {
    return {
      allLabel: this.$t("table.allLabel"),
      placeholderLabel: this.$t("table.placeholderLabel"),
    };
  }

  headers = [
    {
      text: this.$tc("table.headers.category"),
      value: "case_type",
      sortable: true,
      sortBy: "text",
      filterable: false,
    },
    {
      text: this.$tc("table.headers.owner"),
      value: "owner",
      filterable: true,
    },
    {
      text: this.$tc("table.headers.step"),
      value: "case_progress_step_name",
      filterable: true,
      slot: true,
    },
    {
      text: this.$tc("table.headers.status"),
      value: "final_decision",
      filterable: true,
      slot: true,
    },
  ];

  goToCase(item: TCase_Table) {
    const { id, tabId } = item;

    this.$router.push(`/cases/${id}/dashboard/${tabId}`);
  }

  isError(finalDecision?: string | number) {
    return finalDecision === HIGH_RISK_ELIGIBILITY_RESULT;
  }

  get hasCases() {
    return this.cases?.length;
  }

  finalDecisionClasses(item: TCase_Table) {
    const { finalDecision } = item;
    const decision = String(finalDecision);

    return {
      [`${STATUS_COLUMN_CLASS}_low-risk`]: decision.includes("Low risk"),
      [`${STATUS_COLUMN_CLASS}_medium-risk`]: decision.includes("Medium risk"),
      [`${STATUS_COLUMN_CLASS}_high-risk`]: decision.includes("High risk"),
      [`${STATUS_COLUMN_CLASS}_approved`]: decision.includes("Approved"),
      [`${STATUS_COLUMN_CLASS}_rejected`]: decision.includes("Rejected"),
    };
  }

  generateCaseStepHint(item: TCase_Table) {
    const { case_progress_step_name } = item;

    if (case_progress_step_name === CASE_CREATION_SERVICE_STEP)
      return this.$t("table.tooltips.step.expertReview");

    if (case_progress_step_name === DATA_AND_DOCUMENTS_SUBMISSION_SERVICE_STEP)
      return this.$t("table.tooltips.step.dataAndDocumentSubmission");

    if (case_progress_step_name === EXPERT_REVIEW_SUBMISSION_SERVICE_STEP)
      return this.$t("table.tooltips.step.expertReview");

    if (case_progress_step_name === ADDITIONAL_INFO_FOR_EXPERT_SERVICE_STEP)
      return this.$t("table.tooltips.step.additionalInfoForExpert");

    if (case_progress_step_name === PAYMENT_SERVICE_STEP)
      return this.$t("table.tooltips.step.payment");

    if (case_progress_step_name === APPLICATION_SUBMISSION_SERVICE_STEP)
      return this.$t("table.tooltips.step.applicationSubmission");

    if (case_progress_step_name === VISA_DECISION_SERVICE_STEP)
      return this.$t("table.tooltips.step.visaDecision");

    if (case_progress_step_name === COS_CREATION_SERVICE_STEP)
      return this.$t("table.tooltips.step.cosCreation");

    return case_progress_step_name;
  }
}
